module.exports = __webpack_public_path__ + "static/media/millhouse_logo_white.401e1d9a.png";